module.exports = __webpack_public_path__ + "img/mob_home_banner.69caafe6.png";